<template>
  <Layout :removePadding="true" :onlyLogoHeader="true" >
    <div class="d-flex flex-column" style="height: 100%;">
      <div class="flex-grow-1">
        <div
          style="color: var(--primary-color-blue);"
          class="text-center display font-weight-bold"
          :class="$vuetify.breakpoint.smAndDown ? 'pt-3 pb-0' : 'pt-10 pb-5'"
        >
          {{ $t("sign_in.login") }}
        </div>
        <div
          class="mx-10"
          :class="$vuetify.breakpoint.smAndDown ? 'mt-1' : 'mt-3'"
        >
          <v-col style="color: var(--primary-color-blue);" class="py-5" v-for="(field, i) in fields" :key="i">
            <v-row style="font-size: 14px;">
              {{ $t("sign_in." + i) }}*
            </v-row>
            <v-row align="center" justify="space-around">
              <v-text-field
                flat
                solo
                hide-details
                single-line
                :append-icon="
                  i === 'password'
                    ? showPassword
                      ? 'visibility_off'
                      : 'visibility'
                    : null
                "
                @click:append="showPassword = !showPassword"
                v-model="fields[i]"
                :type="
                  i === 'password' ? (showPassword ? 'text' : 'password') : 'text'
                "
                class="input-custom w-100"
              >
              </v-text-field>
              <span v-if="formErrors" class="red--text w-100">{{
                formErrors[i]
              }}</span>
            </v-row>
          </v-col>

          <v-alert
            v-if="formErrors && formErrors.login"
            color="error"
            icon="warning"
            class="subheading py-1 px-2 mb-2"
            outlined
          >
            {{ formErrors ? $t(formErrors.login) : "" }}
          </v-alert>

          <div class="d-flex justify-end align-center" style="color: var(--primary-color-blue); height: 20px; text-decoration: underline; font-weight: 400; font-size: 14px;">
            <p
              class="text-center pt-5 clickable"
              @click="$router.push({ name: routeNames.RECOVER })"
            >
              {{ $t("sign_in.forgot_password") }}
            </p>
          </div>
        </div>

        <div class="mt-5 mx-10">
          <v-btn
            class="px-13 py-7 w-100 semi-rounded text-over-secondary--text"
            style="color: white !important; background: var(--primary-color-blue);"
            x-large
            outlined
            outlined-border-width="7"
            :loading="sentRequest"
            @click="login()"
          >
            {{ $t("sign_in.login") }}
          </v-btn>
          <div v-if="authValuesExists(['google_token']) || authValuesExists(['apple_token'])" class="d-flex align-center my-3">
            <v-divider class="flex-grow-1"></v-divider>
            <span class="mx-3 text-caption" style="color: var(--primary-color-blue);">o</span>
            <v-divider class="flex-grow-1"></v-divider>
          </div>
          <v-btn
            v-if="authValuesExists(['google_token'])"
            style="border-color: var(--primary-color-blue); border-radius: 16px !important;"
            class="px-13 py-7 mb-3 w-100"
            x-large
            outlined
            outlined-border-width="7"
            :loading="sentRequest"
            @click="loginWithGoogle()"
          >
            <v-img
              max-width="25"
              max-height="25"
              class="mr-5"
              :src="googleLogo"
            ></v-img>
            <span style="font-size: 14px; color: var(--primary-color-blue);">
              {{ $t("sign_in.login_with_google") }}
            </span>
          </v-btn>
          <v-btn
            v-if="authValuesExists(['apple_token'])"
            style="border-color: var(--primary-color-blue); border-radius: 16px !important;"
            class="px-13 py-7 w-100"
            x-large
            outlined
            :loading="sentRequest"
            @click="loginWithApple"
          >
            <v-img
              :src="appleLogo"
              alt="Apple logo"
              contain
              max-width="25"
              max-height="25"
              class="mr-5"
            />
            <span style="font-size: 14px; color: var(--primary-color-blue);">
              {{ $t("sign_in.login_with_apple") }}
            </span>
          </v-btn>
          <div class="d-flex justify-space-between pt-3">
            <p >
              {{ $t("sign_in.have_account") }}
            </p>
            <span
              style="text-decoration: underline;"
              class="font-weight-bold clickable"
              @click="$router.push(registerLink)"
              >{{ $t("sign_in.register") }}</span
            >
          </div>
        </div>
      </div>
      <BottomBar :logged="false"/>
    </div>
  </Layout>
</template>

<script>
import Layout from "@/views/layouts/MainLayout";
import { Credentials } from "../entities/request-bodies/Credentials";
import BottomBar from "@/components/BottomBar";

export default {
  name: "LoginView",
  props: ["routeNames", "auth"],
  data() {
    return {
      fields: {
        email: null,
        password: null,
      },
      sentRequest: false,
      showPassword: false,
      formErrors: {
        login: null
      },
      appleLogo: require('@/assets/images/apple_logo.png'),
      googleLogo: require('@/assets/images/google_logo.png'),
      appleToken: null,
      googleToken: null,
      auth_array: [],
      link_array: []
    };
  },
  methods: {
    login() {
      const context = this;
      this.sentRequest = true;
      const useSocialLogin = this.appleToken || this.googleToken;
      if (!useSocialLogin) {
        
        if (!this.fields.email) {
          this.sentRequest = false;
          this.formErrors.login = "sign_in.email_or_password_cannot_be_null"
          return
        }
        if (!this.fields.password) {
          this.sentRequest = false;
          this.formErrors.login = "sign_in.email_or_password_cannot_be_null"
          return
        }
      }
      const credentials = new Credentials(
        useSocialLogin ? null : this.fields.email,
        useSocialLogin ? null : this.fields.password,
        this.appleToken,
        this.googleToken
      );
      this.auth.login(context, credentials).finally(() => {
        context.sentRequest = false;
      });
    },
    loginWithGoogle() {
      window.google.accounts.id.initialize({
        client_id: `${process.env.VUE_APP_GOOGLE_CLIENT_ID}`,
        callback: async (response) => {
          const idToken = response.credential;
          this.authType = "GOOGLE_TOKEN"
          this.googleToken = idToken
          this.login()
        }
      });
      window.google.accounts.id.prompt();
      
    },
    loginWithApple() {
      console.log(window.AppleID);
      console.log("Lanzando AppleID.auth.signIn");
      if (!window.AppleID) {
        alert("El SDK de Apple no está cargado aún");
        return;
      }
      AppleID.auth
        .signIn()
        .then((response) => {
          console.log('Apple response:', response);
          this.authType = "APPLE_TOKEN"
          this.appleToken = response.authorization.id_token
          this.login()
        })
        .catch((error) => {
          console.error("Error login Apple:", error);
        });
    },
    parseAppleJwt(token) {
      try {
        const payload = token.split('.')[1];
        const json = atob(payload.replace(/-/g, '+').replace(/_/g, '/'));
        return JSON.parse(json);
      } catch (e) {
        return null;
      }
    },
    authValuesExists(requiredTypes) {
      return requiredTypes.every(type => this.auth_array.includes(type));
    }
  },
  mounted() {
    if (window.AppleID) {
      window.AppleID.auth.init({
        clientId: `${process.env.VUE_APP_APPLE_CLIENT_ID}`,
        scope: 'name email',
        redirectURI: `${window.location.origin}/apple/sign`,
        state: '',
        usePopup: true,
      });
    }
    this.auth_array = this.$store.getters.customization.auth_array
  },
  async created() {
    this.link_array = this.$store.getters.customization.link_array;
  },
  components: {
    Layout,
    BottomBar
  },
  computed: {
    registerLink() {
      if (this.link_array.length == 1) {
        if (this.link_array[0] === "no_reference") {
          return {
            name: this.routeNames.SIGN_UP_NO_REFERENCE, 
            params: { 
              type: 'no_reference' 
            }
          }
        }else{
            return {
              name: this.routeNames.VALIDATE_TAG_OR_TICKET, 
              params: { 
                type: this.link_array[0] == "ticket" ? "locator" : this.link_array[0]
              }
            }
          }
      }else{
        return { name: this.routeNames.SELECT_SIGN_UP }
      }
    }
  }
};
</script>

<style>
.theme--light.v-btn.v-btn--disabled {
  opacity: 0.5 !important;
}
</style>
